import styled from "styled-components";

const INPUT_DROPDOWN_BG = 'rgba(255, 255, 255, 0.1)';

export const InputDropdownWrapper = styled.fieldset`
    position: relative;
    box-sizing: border-box;
    flex-shrink: 0;
    width: max-content;
    max-width: 100%;
    min-width: ${props => props.$size === 'compact' ? '80px' : '140px'};
    margin: 0;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    background: ${INPUT_DROPDOWN_BG};
    /* Legend position follows the fieldset's text-align, including inherited center. */
    text-align: ${props => props.$align === 'center' ? 'center' : 'left'};
    transition: border-color 0.2s ease-out, box-shadow 0.2s ease-out;

    &:focus-within {
        border-color: rgba(255, 255, 255, 0.45);
        box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12);
    }
`;

/* Keeps the interactive row at PrimaryBtn height; legend sits on the border above */
export const InputDropdownControl = styled.div`
    position: relative;
    box-sizing: border-box;
    height: ${props => props.$size === 'compact' ? '30px' : '38px'};
    display: flex;
    align-items: center;
`;

export const InputDropdownSelect = styled.select`
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: none;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: block;
    flex: 1 1 auto;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-weight: ${props => props.$size === 'compact' ? '500' : '600'};
    font-size: ${props => props.$size === 'compact' ? '12px' : '14px'};
    height: 100%;
    line-height: ${props => props.$size === 'compact' ? '30px' : '38px'};
    margin: 0;
    min-width: ${props => props.$size === 'compact' ? '80px' : '140px'};
    outline: none;
    padding: ${props => props.$align === 'center'
        ? (props.$size === 'compact' ? '0 28px' : '0 36px')
        : (props.$size === 'compact' ? '0 28px 0 8px' : '0 36px 0 12px')};
    text-align: ${props => props.$align === 'center' ? 'center' : 'left'};
    text-align-last: ${props => props.$align === 'center' ? 'center' : 'left'};
    text-indent: 0;
    width: 100%;

    /* Kill global select styles from index.css */
    &.widget-bg,
    &.panel-bg {
        align-items: unset;
        backdrop-filter: none;
        -webkit-backdrop-filter: none;
        background: transparent;
        border: none;
        border-radius: 4px;
        box-shadow: none;
        display: block;
        height: 100%;
        line-height: ${props => props.$size === 'compact' ? '30px' : '38px'};
        padding: ${props => props.$align === 'center'
            ? (props.$size === 'compact' ? '0 28px' : '0 36px')
            : (props.$size === 'compact' ? '0 28px 0 8px' : '0 36px 0 12px')};
        text-align: ${props => props.$align === 'center' ? 'center' : 'left'};
        text-align-last: ${props => props.$align === 'center' ? 'center' : 'left'};
        width: 100%;
    }

    option {
        background-color: #2a2a2a;
        color: #FFFFFF;
        line-height: normal;
    }
`;

/* In-flow legend — creates a real gap in the fieldset border. No float. */
export const InputDropdownLabel = styled.legend`
    display: block;
    width: max-content;
    max-width: 100%;
    padding: 0 5px;
    margin-left: ${props => props.$align === 'center' ? 'auto' : (props.$size === 'compact' ? '4px' : '8px')};
    margin-right: ${props => props.$align === 'center' ? 'auto' : '0'};
    margin-top: 0;
    margin-bottom: 0;
    line-height: 1;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.65);
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: ${props => props.$size === 'compact' ? '10px' : '11px'};
    font-weight: 500;
    background: transparent;
`;

export const InputDropdownIcon = styled.div`
    position: absolute;
    right: ${props => props.$size === 'compact' ? '6px' : '10px'};
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    svg {
        width: ${props => props.$size === 'compact' ? '16px' : '20px'};
        height: ${props => props.$size === 'compact' ? '16px' : '20px'};
    }
`;
